import { useRef } from 'react'
import useStyles from './ControlledSlider.styled'

export const useControlledSlider = props => {
	const { controlVariant } = props
	const sliderRef = useRef(null)
	const classes = useStyles(props)

	const handleNextClick = () => {
		sliderRef.current?.slickNext()
	}

	const handlePrevClick = () => {
		sliderRef.current?.slickPrev()
	}

	return [
		{
			settings: {
				dotsClass: `slick-dots ${classes.dots}`,
				...props,
			},
			classes,
			sliderRef,
			controlVariant,
		},
		{ handleNextClick, handlePrevClick },
	]
}
